import DeviceProps from '@magnus/react-native-device-props';
// import { SMTP_LINK } from 'core/constants/general';

export const sendEmail = async (email: string, templateName: string) => {
  const [idfm, deviceProps] = await Promise.all([DeviceProps.getIDFM(), DeviceProps.fetch()]);

  const preparedDeviceProps = Object.fromEntries(
    Object.entries(deviceProps).map(([k, v]) => ['__' + k + '__', v])
  );

  const argsEvent = {
    idfm,
    uid: idfm,
    app_version: preparedDeviceProps.__app_version__,
    os_version: preparedDeviceProps.__os_version__,
  };

  const options = {
    method: 'POST',
    headers: {
      accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      email,
      template: templateName,
      magnusToken: process.env.REACT_APP_MAGNUS_TOKEN,
      argsEvent,
    }),
  };

  const response = await fetch(
    `${'https://dev.myjoygames.com'}/smtp-email-send`,
    options
  );

  return response.json();
};

export const sendEmailWithDynamicData = async (
  email: string,
  templateName: string,
  variables: Record<string, any>
) => {
  const [idfm, deviceProps] = await Promise.all([DeviceProps.getIDFM(), DeviceProps.fetch()]);

  const preparedDeviceProps = Object.fromEntries(
    Object.entries(deviceProps).map(([k, v]) => ['__' + k + '__', v])
  );

  const argsEvent = {
    idfm,
    uid: idfm,
    app_version: preparedDeviceProps.__app_version__,
    os_version: preparedDeviceProps.__os_version__,
  };

  const options = {
    method: 'POST',
    headers: {
      accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      email,
      template: templateName,
      variables,
      magnusToken: process.env.REACT_APP_MAGNUS_TOKEN,
      argsEvent,
    }),
  };

  const response = await fetch(
    `${'https://dev.myjoygames.com'}/smtp-email-send`,
    options
  );

  return response.json();
};
